export enum Country {
    AE = 'AE',
    AU = 'AU',
    BH = 'BH',
    CA = 'CA',
    CL = 'CL',
    ES = 'ES',
    IL = 'IL',
    IN = 'IN',
    JO = 'JO',
    KW = 'KW',
    MY = 'MY',
    NZ = 'NZ',
    OM = 'OM',
    PL = 'PL',
    QA = 'QA',
    SA = 'SA',
    FR = 'FR',
    IT = 'IT',
    UK = 'UK',
    SN = 'SN'
}


// WEBPACK FOOTER //
// ./src/environment/country.ts